export default __webpack_public_path__ + "static/media/bgPattern.21bdab79.svg";